var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StepLayout',{staticClass:"step-select-building-type",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Tarifas para ahorrar en mi factura")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }